var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4992 3.98242C10.3259 3.98242 3.69922 10.7882 3.69922 19.1824C3.69922 26.8027 9.16535 33.0955 16.2866 34.195V23.2104H12.6249V19.2154H16.2866V16.5566C16.2866 12.155 18.3747 10.2233 21.9365 10.2233C23.6422 10.2233 24.545 10.3538 24.9718 10.412V13.8992H22.5421C21.03 13.8992 20.5022 15.3723 20.5022 17.0316V19.2154H24.9335L24.3329 23.2104H20.5022V34.2266C27.7258 33.2209 33.2992 26.8774 33.2992 19.1824C33.2992 10.7882 26.6725 3.98242 18.4992 3.98242Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c9c9990ff66e40dbced01599186f1eef.svg";
export { ForwardRef as ReactComponent };